import { create } from 'zustand';
import { getMyOrganizations, type MyOrganization } from '../services/organizationService';

interface OrgState {
  activeOrgId: string | null;
  organizations: MyOrganization[];
  loading: boolean;

  setActiveOrgId: (orgId: string | null) => void;
  switchOrg: (orgId: string) => void;
  fetchOrganizations: () => Promise<MyOrganization[]>;
  reset: () => void;
}

export const useOrgStore = create<OrgState>()((set, get) => ({
  activeOrgId: localStorage.getItem('activeOrgId'),
  organizations: [],
  loading: false,

  setActiveOrgId: (orgId) => {
    if (orgId) {
      localStorage.setItem('activeOrgId', orgId);
    } else {
      localStorage.removeItem('activeOrgId');
    }
    set({ activeOrgId: orgId });
  },

  switchOrg: (orgId) => {
    get().setActiveOrgId(orgId);
  },

  fetchOrganizations: async () => {
    set({ loading: true });
    try {
      const orgs = await getMyOrganizations();
      set({ organizations: orgs });

      // activeOrgId가 없거나 목록에 없으면 첫 번째 조직으로 설정
      const currentId = get().activeOrgId;
      const valid = currentId && orgs.some((o) => o.id === currentId);
      if (!valid && orgs.length > 0) {
        get().setActiveOrgId(orgs[0].id);
      } else if (orgs.length === 0) {
        get().setActiveOrgId(null);
      }

      return orgs;
    } catch (err: any) {
      // 인증 에러(401)는 세션 만료 → 빈 배열이 아닌 에러를 throw하여
      // AppLayout에서 온보딩이 아닌 로그인으로 리다이렉트하도록 함
      if (err?.response?.status === 401 || err?.status === 401) {
        throw err;
      }
      return [];
    } finally {
      set({ loading: false });
    }
  },

  reset: () => {
    localStorage.removeItem('activeOrgId');
    set({ activeOrgId: null, organizations: [], loading: false });
  },
}));
